import { render, staticRenderFns } from "./MyCart.vue?vue&type=template&id=240277de&scoped=true&"
import script from "./MyCart.vue?vue&type=script&lang=js&"
export * from "./MyCart.vue?vue&type=script&lang=js&"
import style0 from "./MyCart.vue?vue&type=style&index=0&id=240277de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240277de",
  null
  
)

export default component.exports